import { ReferenceFootnoteRow } from '@/components/chat/bubbles/references/ReferenceFootnoteRow';
import type { MessageReference } from '@/components/chat/bubbles/references/messageReferences';
import { VStack } from '@/components/ui/vstack';

interface MessagePublicationsFooterProps {
  references: readonly MessageReference[];
  position: 'left' | 'right';
  onOpenReference: (reference: MessageReference) => void;
}

/**
 * The reference list for a message with no extracted statements, drawn
 * inside the bubble below its text. It matches the statement footer's frame
 * and rows so a reader sees one kind of reference list whichever bubble a
 * message gets.
 */
export function MessagePublicationsFooter({
  references,
  position,
  onOpenReference,
}: MessagePublicationsFooterProps) {
  if (references.length === 0) {
    return null;
  }

  return (
    <VStack className="mt-2 border-t border-outline-200">
      {references.map((reference) => (
        <ReferenceFootnoteRow
          key={reference.number}
          reference={reference}
          position={position}
          onPress={onOpenReference}
        />
      ))}
    </VStack>
  );
}
